import type { ResultOf } from '@graphql-typed-document-node/core'
import { useIsPC } from '~/lib/ua'
import { css, sva } from '~/styled-system/css'
import { Access } from './Access'
import type { GetRestaurantAccess } from './GetResutaurantAccess.graphql'
import { GuideAccess } from './GuideAccess'
import { Map } from './Map'

type Props = {
  restaurant: ResultOf<typeof GetRestaurantAccess>['restaurant']
}

const styles = sva({
  slots: ['container', 'address', 'access'],
  base: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      _pc: {
        rowGap: '5',
      },
    },
    address: {
      borderBottom: 'dotted',
      backgroundColor: 'white',
      p: '3',
      _pc: {
        display: 'flex',
        alignItems: 'center',
        columnGap: '1',
        fontSize: 'md',
        p: '0',
        borderBottom: 'none',
      },
    },
    access: {
      position: 'absolute',
      left: '0',
      top: '0',
      zIndex: '10',
      width: 'full',
      backgroundColor: 'white',
      shadow: 'outline.md',
    },
  },
})

export function GuideAccessFusuma({ restaurant }: Props) {
  const isPc = useIsPC()
  if (restaurant === null) {
    return null
  }
  const classes = styles()
  return (
    <GuideAccess bodyClassName={classes.container}>
      <div className={classes.address}>{restaurant.fullAddress}</div>
      {/* spは地図上に行き方を表示 */}
      {!isPc && (
        <div className={css({ position: 'relative' })}>
          {/* 高さをあわせるために &nbsp; を入れている */}
          <div className={css({ p: '3' })}>&nbsp;</div>
          <div className={classes.access}>
            <Access restaurant={restaurant} />
          </div>
        </div>
      )}
      <Map fragment={restaurant} className={css({ _sd: { flexGrow: '1' } })} />
      {/* pcは地図下に行き方を表示 */}
      {isPc && <Access restaurant={restaurant} />}
    </GuideAccess>
  )
}
